import Vue from 'vue';
import moment from 'moment';
import flatpickr from 'flatpickr';
import { dateFormat, dateTimeFormat } from '.';

interface DatePicker {
  open(): void,
  close(): void,
  setDate(value: string|string[]|null): void,
}

interface Data {
  flatpickr: DatePicker|null,
  mode: string,
}

export default Vue.extend({
  props: {
    value: String,
    format: String,
    minDate: String,
    maxDate: String,
    time: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      flatpickr: null,
      mode: 'single',
    };
  },
  computed: {
    humanValue(): string|null {
      return this.value ? this.formatValue(this.value) : null;
    },
    displayFormat(): string {
      if (this.format) return this.format;
      if (this.time) return dateTimeFormat;
      return dateFormat;
    },
  },
  watch: {
    value(value: string|null) {
      this.setFlatpickrDate(value);
    },
  },
  methods: {
    setFlatpickrDate(value: string|null) {
      if (this.flatpickr) {
        this.flatpickr.setDate(value);
      }
    },
    createFlatpickr() {
      // @ts-ignore
      this.flatpickr = flatpickr(this.$el, {
        defaultDate: this.value,
        mode: this.mode,
        onChange: this.onChange,
        enableTime: this.time,
        disableMobile: true,
        minDate: this.minDate,
        maxDate: this.maxDate,
      });
    },
    open(): void {
      if (!this.flatpickr) {
        this.createFlatpickr();
      }
      if (this.flatpickr) {
        this.flatpickr.open();
      }
    },
    clear(): void {
      if (this.flatpickr) {
        this.$emit('input', null);
        this.flatpickr.close();
      }
    },
    formatValue(value: string): string {
      return moment(value).format(this.displayFormat);
    },
    onChange(dates: Date[]): void {
      if (!dates.length) {
        this.$emit('input', null);
        return;
      }
      const now = Math.floor((new Date()).getTime() / 1000);
      const date = Math.floor(dates[0].getTime() / 1000);
      /**
       * Flatpickr emits change event even when date is not picked.
       */
      if (now === date) return;
      const value = (this.time)
        ? moment(dates[0]).utc().toISOString()
        : moment(dates[0]).format('YYYY-MM-DD');
      this.$emit('input', value);
    },
  },
  mounted(): void {
    this.createFlatpickr();
  },
});
